<template>
  <section class="bg-white rounded-xl border border-gray-100 shadow-sm p-5 md:p-6">
    <div class="tw-flex items-center justify-between mb-4">
      <h3 class="text-base font-semibold text-gray-900 m-0">Inform (Knowledge Base)</h3>
    </div>
    <p class="text-sm text-gray-500 mt-0 mb-3">The graph below shows the evolution of total resources and the interaction amongst them.</p>

    <div v-if="inform.total_resources || inform.total_views || inform.total_downloads" class="chart-container">
      <div class="chart-main">
        <SimpleLineChart :data="chartData" :show-final-value="true"/>
      </div>
      <div class="chart-aside">
        <ChartLegend :data="chartData" :show-final-value="true"/>
      </div>
    </div>

    <div v-if="showMostPopularResources" class="mt-6">
      <h4 class="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">Most popular resources</h4>
      <div class="overflow-x-auto">
        <table class="w-full text-sm border-collapse">
          <thead>
          <tr class="border-b border-gray-200 text-left text-xs font-semibold uppercase tracking-wide text-gray-400">
            <th class="py-2 pr-4 font-semibold">Resource title</th>
            <th class="py-2 font-semibold">Unique users</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="resource in mostPopularResources" class="border-b border-gray-100 hover:bg-gray-50">
            <td class="py-2 pr-4 text-gray-700">{{ resource.title }}</td>
            <td class="py-2 text-gray-600">{{ resource.unique_views }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </section>
</template>

<script>
  import EcosystemInfoCard from './EcosystemInfoCard.vue'
  import ChartLegend from './ChartLegend.vue'
  import { parseChartData } from '../../Chart/chartsMixin.js'
  import SimpleLineChart from '../../Chart/SimpleLineChart.vue'

  export default {
    props: {
      inform: Object,
      mostPopularResources: Object,
    },
    components: {
      EcosystemInfoCard,
      ChartLegend,
      SimpleLineChart,
    },
    data () {
      return {
        showMostPopularResources: false,
      }
    },
    computed: {
      chartData () {
        if (!!this.mostPopularResources && typeof this.mostPopularResources === 'object') {
          this.showMostPopularResources = Object.keys(this.mostPopularResources).length > 0
        }
        const datasets = []

        if (this.inform.total_resources != null) {
          datasets.push({
            color: '#FBA52C',
            data: this.inform.total_resources_per_month,
            finalValue: this.inform.total_resources,
            cumulate: true,
            label: 'Total resources',
          })
        }

        if (this.inform.total_views != null) {
          datasets.push({
            color: '#2E59FA',
            data: this.inform.total_views_per_month,
            finalValue: this.inform.total_views,
            cumulate: true,
            label: 'Total views',
          })
        }

        if (this.inform.total_downloads != null) {
          datasets.push({
            color: '#AF52FF',
            data: this.inform.total_downloads_per_month,
            cumulate: true,
            finalValue: this.inform.total_downloads,
            label: 'Total downloads',
          })
        }

        return parseChartData(datasets)
      },
    },
    methods: {
      convertUrl (pageUrl) {
        return `${window.location.protocol}//${window.location.hostname}${pageUrl}`
      },
    },
  }
</script>
